import SportDetails from "./SportDetails";
export default SportDetails;
